import { createRouter, createWebHistory } from "vue-router";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/forms/:id",
      component: () => import("./modules/forms/forms.view.vue"),
    },
    {
      path: "/:pathMatch(.*)*",
      component: () => import("./modules/default/default.view.vue"),
    },
  ],
});

export default router;
